import React, { useState } from "react";
import Header from "./Header/Header";
import NavBar from "../components/NevBar/Navigation";
import { Heading } from "rsuite";

const Layout = ({ children, title, heading }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen w-full min-w-full">
      {/* Header stays on top full width */}
      {/* <Header heading={heading} /> */}

      <div className="flex ">
        {/* Sidebar stays below header, left aligned */}
        <NavBar />

        {/* Main Content */}
        <main className="main-content flex-grow ">{children}</main>
      </div>
    </div>
  );
};

export default React.memo(Layout);
